import { api } from '@/lib/api-client.ts'
import { AxiosResponse } from 'axios'
import handleApiErr from '@/lib/helpers/handleApiGerError.ts'
import {
  NotificationsDataT,
  NotificationT,
} from '@/routes/projectStages/notifications/lib/types/notificationsTypes.ts'

export const getNotificationsByStageIdQuery = (stageId: string) => ({
  queryKey: ['getNotificationsByStageId', stageId],
  queryFn: ({ pageParam = 1 }) => getNotificationsByStageId(stageId, pageParam, false),
  getNextPageParam: (lastPage: GetNotificationsReturnT) => lastPage?.nextPage,
  initialPageParam: 1,
  staleTime: 1000 * 30,
})

export const getUnreadNotificationsByStageIdQuery = (stageId: string) => ({
  queryKey: ['getUnreadNotificationsByStageId', stageId],
  queryFn: ({ pageParam = 1 }) => getNotificationsByStageId(stageId, pageParam, true),
  getNextPageParam: (lastPage: GetNotificationsReturnT) => lastPage?.nextPage,
  initialPageParam: 1,
  staleTime: 1000 * 30,
})

export type GetNotificationsReturnT = {
  notifications: NotificationT[]
  allNotificationsCount: number
  nextPage: number | null
  currentPage: number
} | null

async function getNotificationsByStageId(
  stageId: string,
  page: number,
  unread?: boolean,
): Promise<GetNotificationsReturnT> {
  let url = `/project_stages/${stageId}/notifications?page=${page}`
  if (unread) {
    url = `/project_stages/${stageId}/notifications/unread?page=${page}`
  }

  try {
    const response: AxiosResponse<NotificationsDataT> = await api.get(url)
    const notifications: NotificationT[] = response.data[`hydra:member`]
    const allNotificationsCount: number = response.data[`hydra:totalItems`] ?? 0
    const hasNextPage =
      page * notifications.length < allNotificationsCount && notifications.length > 0
    return {
      notifications,
      allNotificationsCount,
      nextPage: hasNextPage ? page + 1 : null,
      currentPage: page,
    }
  } catch (err) {
    handleApiErr(err)
    return null
  }
}

export async function markNotificationAsUnread(notificationIri: string) {
  return api.patch(notificationIri, { markedAsUnread: true })
}
